import React, { KeyboardEvent, useState } from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { withLocalePrefix } from 'shared/utils/translation';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import {
  IconButton,
  SecondaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Body } from '@grnhse/seedling/lib/birch/typography';
import { Skill } from 'talent_matching/types';
import CloseIcon from '@grnhse/seedling/lib/birch/icons/close';

const t = withLocalePrefix(
  'talent_matching.modals.calibration.calibrate_skills'
);

const AddSkillField = () => {
  const [skill, setSkill] = useState('');
  const [showInput, setShowInput] = useState(false);
  const { setValue, watch } = useFormContext();

  const skills = watch('skills');

  const onSubmit = () => {
    const newSkill = skill.trim();
    if (!newSkill) {
      return;
    }

    if (
      skills
        .map((s: Skill) => s.name.toLowerCase())
        .includes(newSkill.toLowerCase())
    ) {
      return;
    }

    setValue(
      'skills',
      [...skills, { name: newSkill, importance: 3, newManuallyAdded: true }],
      { shouldDirty: true }
    );
    setSkill('');
    setShowInput(false);
  };

  const onCancel = () => {
    setSkill('');
    setShowInput(false);
  };

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {!showInput && <Body>{t('or')}</Body>}

      {!showInput && (
        <SecondaryButton onClick={() => setShowInput(true)} size="sm">
          {t('add_manually')}
        </SecondaryButton>
      )}

      {showInput && (
        <Stack direction="row" spacing={1}>
          <TextInput
            id="add-skill-input"
            ariaLabel={t('skill_placeholder')}
            onChange={(e) => setSkill(e.target.value)}
            onKeyUp={(e) => e.key === 'Enter' && skill && onSubmit()}
            onKeyDown={onKeyDown}
            value={skill}
            autoFocus
            placeholder={t('skill_placeholder')}
          />
          <Stack direction="row" spacing={1} sx={{ paddingTop: 0.5 }}>
            <SecondaryButton
              size="md"
              onClick={onSubmit}
              disabled={!skill.trim()}
            >
              {t('add')}
            </SecondaryButton>
            <IconButton
              label={t('cancel')}
              onClick={onCancel}
              icon={CloseIcon}
            />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};

export default AddSkillField;
